import { setCoinsState } from '@/actions/coins';
import { useSignalROn } from '@/hooks/useSignalROn';
import { useDispatch, useSelector } from 'react-redux';
import CoinsEarnedSound from '@/assets/sounds/coins_earned.mp3';
import CoinsSpentSound from '@/assets/sounds/coins_spent.mp3';
import { useRef } from 'react';

const CoinEarnedAudio = new Audio(CoinsEarnedSound);
const CoinSpentAudio = new Audio(CoinsSpentSound);

export const CoinsProvider = () => {
  const dispatch = useDispatch();
  const currentBalance = useSelector(s => s.user.coins.currentBalance);
  const currentlyMuted = useSelector(s => s.user.coins.mute);
  const lastUpdateTime = useRef(0);

  const playSound = newBalance => {
    // 250ms (0.25s) delay between each sound
    if (lastUpdateTime.current + 250 > Date.now()) {
      return;
    }

    lastUpdateTime.current = Date.now();

    if (currentBalance < newBalance) {
      CoinEarnedAudio?.play().catch(e => {
        console.log(
          'Could not play audio, most likely user permission issue',
          e
        );
      });
    } else if (currentBalance > newBalance) {
      CoinSpentAudio?.play().catch(e =>
        console.log(
          'Could not play audio, most likely user permission issue',
          e
        )
      );
    }
  };

  useSignalROn('CoinWalletUpdated', async state => {
    if (!currentlyMuted) {
      playSound(state.currentBalance);
    }

    dispatch(setCoinsState(state));
  });

  return null;
};
